
import { LineChart, Activity, Brain, ServerCog } from "lucide-react";
import AnimatedSection from "./AnimatedSection";

const useCases = [
  {
    icon: <Brain className="h-8 w-8 text-primary" />,
    title: "Bayesian A/B Testing",
    description: "Make faster, more accurate decisions with less data than traditional methods."
  },
  {
    icon: <LineChart className="h-8 w-8 text-primary" />,
    title: "Predictive Modelling",
    description: "Build models with uncertainty estimates for more informed decision-making."
  },
  {
    icon: <Activity className="h-8 w-8 text-primary" />,
    title: "Customer Lifetime Value",
    description: "Calculate more accurate CLV projections with Bayesian methods."
  },
  {
    icon: <ServerCog className="h-8 w-8 text-primary" />,
    title: "Churn Prediction",
    description: "Identify at-risk customers earlier with confidence-based probabilistic models."
  }
];

const UseCases = () => {
  return (
    <section id="use-cases" className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <AnimatedSection className="text-center mb-16">
          <span className="text-xs font-medium tracking-wider text-primary uppercase">Applications</span>
          <h2 className="mt-4 text-3xl font-display font-bold tracking-tight">
            Practical Use Cases
          </h2>
          <div className="mt-4 w-20 h-1 bg-primary/30 mx-auto"></div>
          <p className="mt-6 text-neutral-600 max-w-2xl mx-auto">
            Our Bayesian approach delivers more accurate insights for these common business challenges.
          </p>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {useCases.map((useCase, index) => (
            <AnimatedSection 
              key={index}
              animation="fade-in"
              delay={index * 100}
              className="bg-neutral-50 rounded-lg p-8 shadow-sm border border-neutral-100 hover:shadow-md transition-all duration-300"
            >
              <div className="flex items-start">
                <div className="p-3 rounded-lg bg-primary/10 mr-4">
                  {useCase.icon}
                </div>
                <div>
                  <h3 className="text-lg font-display font-semibold mb-2">
                    {useCase.title}
                  </h3>
                  <p className="text-neutral-600 text-sm">
                    {useCase.description}
                  </p>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
